import { UseFormReturnType } from '@mantine/form';
import { useMemo } from 'react';

import { MultiLangCodes, TextInput } from '@components';
import { TRANSIT_AUTOCOMPLETE_DEFAULT_WIDTH } from '@constants';
import { useCodeListSystem } from '@hooks/useCodeListSystem';

interface TransitAutocompleteHeaderProps {
  form: UseFormReturnType<any>;
  parents: any[];
  name: string;
  disabled: boolean;
  width?: number;
  placeholder?: string;
  code: string;
}

export const TransitAutocompleteHeader: React.FC<TransitAutocompleteHeaderProps> = ({
  form,
  parents,
  name,
  disabled,
  width = TRANSIT_AUTOCOMPLETE_DEFAULT_WIDTH,
  placeholder,
  code,
}) => {
  const parentValue = useMemo(() => parents.find((parent) => !!parent), [parents]);
  const codelistSystems = useCodeListSystem({ isTransit: true });

  return (
    <>
      {!parentValue ? (
        <MultiLangCodes {...form.getInputProps(name)} code={code} label={placeholder} disabled={disabled} system={codelistSystems} />
      ) : (
        <TextInput {...form.getInputProps(name)} label={placeholder} value={parentValue} disabled />
      )}
    </>
  );
};
